import './styles/EmptyResult.scss';

const EmptyResult = () => (
    <div className='EmptyResult'>
        <span className='rioglyph rioglyph-looking-glass-man EmptyResult__icon' />
        <p className='EmptyResult__text EmptyResult__text--bold'>No results were found</p>
    </div>
);

export default EmptyResult;
